import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ADD_HACKATHON_URL } from 'src/constants/configuration';
import { user, modalWindows } from 'src/actions';
import { Mixpanel } from '../../Mixpanel';

import './Tokens.scss';


const TokenHint = (props) =>(
  <div className="tokens__hint">
    <h2 className='hint__points'>+{props.value}ht</h2>
    <p className="hint__text">
      <button className='hint__btn' onClick={props.onHintClick}>
        {props.linkText}
      </button> {props.text}
    </p>
  </div>
)
TokenHint.propTypes = {
  linkText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onHintClick: PropTypes.func.isRequired,
}


class Tokens extends Component {
  constructor() {
    super();
    this.state = {
      newTokens: [{
        id: 1,
        linkText: 'Добавить',
        text: 'хакатон в календарь',
        value: 100,
        onHintClick: () => {Mixpanel.track('Account', {'Tokens' : 'Add hackathon'}); this.props.history.push(ADD_HACKATHON_URL, { from: 'account' })},
      }, {
        id: 2,
        linkText: 'Поделиться',
        text: 'материалом',
        value: 150,
        onHintClick: () => {Mixpanel.track('Account', {'Tokens' : 'Add news'}); this.props.openShareNewsModal()},
      }, {
        id: 3,
        linkText: 'Оставить отзыв',
        text: 'о хакатоне',
        value: 200,
        onHintClick: () => {Mixpanel.track('Account', {'Tokens' : 'Add review'}); this.props.openAddReviewModal()},
      }]
    }
  }
  
  render() {
    const { wallet } = this.props;
    return (
      <div className='cabinet_tokens'>
        <div className="tokens__info">
          <div className="info__balance">
            <h1>{wallet.tokens}ht</h1>
            <p title="Скоро можно будет использовать в нашем магазине">баланс
              <sup className='after-number'>?</sup>
            </p>
          </div>
          <div className="info__rating">
            <p className='info__rating__line'>top {wallet.place * 100}%</p>
            <p className='info__rating__line'>текущее место</p>
            <p className='info__rating__line'>в рейтинге сезона</p>
          </div>
        </div>
        <div className="tokens__separate-line">
          <div className="separate-line__text">Получить токены</div>
        </div>
        <div className="tokens__get">
        {
          this.state.newTokens.map((newToken, i) => {
            return (
              <TokenHint 
                key={newToken.id}
                onHintClick={newToken.onHintClick}
                linkText={newToken.linkText}
                text={newToken.text}
                value={newToken.value}
              />
            )
          })
        }
        </div>
      </div>
    );
  }
}


Tokens.propTypes = {
  wallet: PropTypes.shape({
    rating: PropTypes.number.isRequired,
    tokens: PropTypes.number.isRequired,
    place: PropTypes.number.isRequired,
  }),
  refetchUserWallet: PropTypes.func.isRequired,
  openShareNewsModal: PropTypes.func.isRequired,
  openAddReviewModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  })
}

function mapStateToProps(state) {
  return {
    wallet: state.user.wallet,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    refetchUserWallet: user.refetchUserWallet,
    openShareNewsModal: modalWindows.openShareNewsModal,
    openAddReviewModal: modalWindows.openAddReviewModal,
  })(Tokens)
);



// WEBPACK FOOTER //
// ./src/components/Account/Tokens/index.js